import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, ArrowUpRight } from "lucide-react";

const cols = [
  {
    title: "Shop",
    links: [
      { label: "The Car Scent Kit", to: "/shop/car-scent-kit" },
      { label: "The Home Diffuser", to: "/shop/home-diffuser" },
      { label: "Fragrance Oils", to: "/shop" },
      { label: "Refill Foil", to: "/shop/refill-foil" },
    ],
  },
  {
    title: "Explore",
    links: [
      { label: "Home", to: "/" },
      { label: "Shop", to: "/shop" },
      { label: "Commercial Scenting", to: "/commercial-scenting" },
      { label: "Information", to: "/info" },
      { label: "Business Enquiries", to: "/enquiries" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Our Promise", to: "/info" },
      { label: "Compliance", to: "/info" },
      { label: "FAQ", to: "/info" },
      { label: "Enquire", to: "/enquiries" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="relative bg-[#eae2d3] border-t border-[#d9cdba] pt-24 pb-10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20">
          <div className="md:col-span-4">
            <img src="/logo-dark.png" alt="The Scent Butler" className="h-28 w-auto object-contain -ml-2" />
            <p className="text-[#6f6252] text-sm leading-relaxed mt-6 max-w-xs">
              Premium commercial scent solutions that create unforgettable experiences for
              businesses across Australia.
            </p>
            <div className="flex gap-3 mt-8">
              {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 grid place-items-center border border-[#d9cdba] text-[#6f6252] hover:text-gold hover:border-goldline transition-colors duration-300"
                  data-testid={`footer-social-${i}`}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <p className="eyebrow mb-6">{col.title}</p>
              <ul className="space-y-3">
                {col.links.map((l, i) => (
                  <li key={i}>
                    <Link
                      to={l.to}
                      className="text-sm text-[#6f6252] hover:text-[#201a12] transition-colors duration-300"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <p className="eyebrow mb-6">Let's Connect</p>
            <a
              href="tel:1300123456"
              className="block text-sm text-[#6f6252] hover:text-[#201a12] transition-colors mb-3"
            >
              1300 123 456
            </a>
            <a
              href="mailto:hello@thescentbutler.com.au"
              className="text-sm text-gold link-underline inline-flex items-center gap-1"
            >
              hello@thescentbutler.com.au <ArrowUpRight size={13} />
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-[#d9cdba] flex flex-col md:flex-row justify-between gap-4 text-xs text-[#8a7c68]">
          <p>© {new Date().getFullYear()} The Scent Butler. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-[#201a12] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#201a12] transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
